<template>
<div>
   <v-menu
        v-model="aDate"
        :close-on-content-click="false"
        transition="scale-transition"
        offset-y
        max-width="100%"
        min-width="auto"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-text-field
            v-model="dateFormatted"
            :label="label"
            placeholder="DD/MM/YYYY"
            prepend-icon=""
            append-icon="mdi-calendar"
            v-bind="attrs"
            @blur="date = parseDate(dateFormatted)"
            v-on="on"
            clearable
            readonly
            :dense="dense === false ? false : true"
            :outlined="outlined === false ? false : true"
            hide-details="hide_details"
            @click:clear="date = null"
        ></v-text-field>
      </template>
      <v-date-picker
      v-model="date"
      no-title
      @input="aDate = false"
      ></v-date-picker>
    </v-menu>
</div>
</template>

<script>
export default {
  name: 'Datepicker',
  props: ['label', 'value', 'dense', 'outlined', 'solo', 'hide_details', 'onChange'],
  data: (vm) => ({
    date: vm.value,
    dateFormatted: vm.formatDate(vm.value),
    aDate: false
  }),
  computed: {
    computedDateFormatted () {
      return this.formatDate(this.date)
    }
  },
  watch: {
    date (val) {
      this.dateFormatted = this.formatDate(this.date)
      this.$emit('input', this.date)
      if (this.onChange) {
        this.onChange(this.date)
      }
    }
  },
  methods: {
    formatDate (date) {
      if (!date) return null
      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },
    parseDate (date) {
      if (!date) return null
      const [day, month, year] = date.split('/')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },
    getDate() {
      return this.date
    },
    getDateFormat() {
      return this.formatDate(this.date)
    }
  }
}
</script>
